import type { MittwaldAPIV2 } from "@mittwald/api-client-NEXT";

export type CronjobData =
  MittwaldAPIV2.Operations.CronjobGetCronjob.ResponseData;

export type CronjobListItemData =
  MittwaldAPIV2.Operations.CronjobListCronjobs.ResponseData[number];

export type CronjobListQueryData =
  MittwaldAPIV2.Paths.V2ProjectsProjectIdCronjobs.Get.Parameters.Query;

export type CronjobCreateRequestData =
  MittwaldAPIV2.Components.Schemas.CronjobCronjobRequest;

export type CronjobUpdateRequestData =
  MittwaldAPIV2.Paths.V2CronjobsCronjobId.Patch.Parameters.RequestBody;

export type CronjobUpdateAppIdRequestData =
  MittwaldAPIV2.Paths.V2CronjobsCronjobIdAppId.Patch.Parameters.RequestBody;

export type CronjobUrlDestination =
  MittwaldAPIV2.Components.Schemas.CronjobCronjobUrl;

export type CronjobCommandDestination =
  MittwaldAPIV2.Components.Schemas.CronjobCronjobCommand;

export interface CronjobInterpreter {
  path: string;
  name: string;
  extensions: string[];
}

/* interpreters available in every appInstallation */
export const defaultCronInterpreters: CronjobInterpreter[] = [
  {
    path: "/usr/bin/bash",
    name: "Bash",
    extensions: [".sh"],
  },
];

/* interpreters that have to be available within the appInstallation to be listed */
export const additionalCronInterpreters: CronjobInterpreter[] = [
  {
    path: "/usr/bin/php",
    name: "PHP",
    extensions: [".php", ".phtml"],
  },
  {
    path: "/usr/local/bin/python",
    name: "Python",
    extensions: [".py"],
  },
];

export type CronjobLogData =
  MittwaldAPIV2.Operations.ProjectFileSystemGetFileContent.ResponseData;
